import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOptionsTailored = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "optionsTailoredForYou",
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12486",
			"data-name": "Path 12486",
			d: "M0,0H30V30H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12487",
			"data-name": "Path 12487",
			d: "M20,9.25,21.25,8",
			transform: "translate(5 2)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12488",
			"data-name": "Path 12488",
			d: "M21.25,16.25,20,15",
			transform: "translate(5 3.75)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12489",
			"data-name": "Path 12489",
			d: "M22,12h1.25",
			transform: "translate(5.5 3)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12490",
			"data-name": "Path 12490",
			d: "M4.25,15,3,16.25",
			transform: "translate(0.75 3.75)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12491",
			"data-name": "Path 12491",
			d: "M3,8,4.25,9.25",
			transform: "translate(0.75 2)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12492",
			"data-name": "Path 12492",
			d: "M2.25,12H1",
			transform: "translate(0.25 3)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12494",
			"data-name": "Path 12494",
			d: "M9.5,4H17a2.5,2.5,0,0,1,2.5,2.5v15A2.5,2.5,0,0,1,17,24H9.5A2.5,2.5,0,0,1,7,21.5V6.5A2.5,2.5,0,0,1,9.5,4Z",
			transform: "translate(1.75 1)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12503",
			"data-name": "Path 12503",
			d: "M12.3,15l1.5-3H10.2l1.5-3",
			transform: "translate(3 3)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		})
	]
});
export default SvgOptionsTailored;
